import GlobalAxios from "../axios/axios-config";

export class GenericService<T extends object> {
  route_path: string;

  constructor(rp: string) {
    this.route_path = rp;
  }

  listGeneric = (params?: any) => {
    return GlobalAxios.get<T[]>(this.route_path, {
      params: params,
    });
  };
}
